<template>
  <div>
    path: {{ path }} - calcStep: {{ calcStep }} - calculated: {{ calculated }} - configured:
    {{ configured }} - printView: {{ printView }} - verifyView: {{ verifyView }} - designView:
    {{ designView }} - selectionView: {{ selectionView }} - warningsView: {{ warningsView }} -
    bHasWarnings: {{ bHasWarnings }} - bHasBlockingWarnings: {{ bHasBlockingWarnings }} -
  </div>
</template>

<script>
import jsonHelper from "../../shared/jsonHelper";

export default {
  name: "ProjectViewDebugger",
  props: {
    project: { type: Object, required: true },
    projects: { type: Object, required: true },
    path: { type: String, required: true },
    calculated: { type: Boolean, required: true },
    configured: { type: Boolean, required: true },
    printView: { type: Boolean, required: true },
    verifyView: { type: Boolean, required: true },
    designView: { type: Boolean, required: true },
    selectionView: { type: Boolean, required: true },
    warningsView: { type: Boolean, required: true },
    bHasWarnings: { type: Boolean, required: true },
    bHasBlockingWarnings: { type: Boolean, required: true },
    isSelezionePreCalcolo: { type: Boolean, required: true },
    isReturnToSelectionList: { type: Boolean, required: true },
    isOpen: { type: Boolean, required: true }
  },
  data() {
    return {
      calcStepExt: ""
    };
  },
  computed: {
    calcStep: function() {
      if (this.projects && this.project.path) {
        return this.leggiValore("calcStep");
      }
      if (this.calcStepExt) {
        return this.calcStepExt;
      }
      return "";
    }
  },
  mounted: function() {
    var that = this;
    that.$store.subscribe(function(mutation /*, state*/) {
      if (mutation.type === "refreshAll") {
        that.calcStepExt = that.leggiValore("calcStep");
      }
    });
  },
  methods: {
    leggiValore(elemento) {
      return jsonHelper.getProperty(this.projects, this.project.path + "." + elemento);
    }
  }
};
</script>
